import withNavigate from "../../../routes/withNavigate";
import HomePageCmsContainer from "./HomePageCmsContainer.jsx";
import HomePageCmsStore from "./HomePageCmsStore";

export default HomePageCmsStore(withNavigate(HomePageCmsContainer));